import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLazySelector } from 'hooks'
import { BannerNotifications } from 'modules/Notifications/components'
import { setBannerViewedState } from 'modules/Notifications/slices/notifications'
import { BannerNotificationsUtils } from 'modules/Notifications/utils'

const BannerNotificationsContainer: React.FC = () => {
  const dispatch = useDispatch()
  const { bannerInformation, bannerViewed } = useLazySelector(({ notifications, system }) => {
    const { bannerViewed } = notifications
    const bannerInformation = system.customerInformation?.result?.information?.bannerMessageSettings
    return {
      bannerInformation,
      bannerViewed,
    }
  })

  const storageBannerNotificationsViewed =
    BannerNotificationsUtils.getBannerNotificationsState() === BannerNotificationsUtils.viewed

  const bannerNotificationsViewed = bannerViewed || storageBannerNotificationsViewed

  useEffect(() => {
    dispatch(setBannerViewedState(bannerNotificationsViewed))
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function handleClose() {
    BannerNotificationsUtils.markBannerNotificationsViewed()
    dispatch(setBannerViewedState(true))
  }

  const { isBannerMessageEnable, bannerMessage } = bannerInformation || {}

  const isShowBannerNotification = !!isBannerMessageEnable && !!bannerMessage && !bannerViewed

  return (
    <BannerNotifications
      bannerNotification={bannerInformation}
      isShow={isShowBannerNotification}
      onClose={handleClose}
    />
  )
}

export default BannerNotificationsContainer
